import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { IUserData, UserPageBaseComponent } from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { UserContactDetailsWebComponent } from '../../organisms/user-contact-details/user-contact-details.component';
import { ProfileDetailsWebComponent } from '../../organisms/profile-details/profile-details.component';
import { SideSheetService, TicketingGuardService } from '../../../services';
import { AsyncPipe } from '@angular/common';
import { UserProfileEditComponent } from './user-profile-edit/user-profile-edit.component';
import { ROUTE } from '../../../models';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProfileDetailsWebComponent,
    UserContactDetailsWebComponent,
    TranslateModule,
    AsyncPipe,
    ImmomioButtonComponent,
  ],
})
export class UserProfileWebComponent extends UserPageBaseComponent {
  @Input() userData: IUserData;
  #sideSheetService = inject(SideSheetService);
  #ticketingGuard = inject(TicketingGuardService);

  public editProfile(): void {
    if (this.hasMasterDataChangeConfig()) {
      this.#sideSheetService.open(UserProfileEditComponent);
    } else {
      this.#ticketingGuard.setPath(ROUTE.REQUESTS);
      void this.routerService.navigate([ROUTE.TICKETS, ROUTE.REQUESTS]);
    }
  }
}
